// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"145cfdf5","47":"baf294d5","163":"d45e2fb4","187":"d7e21d16","188":"d3353f12","324":"ae7dbf3d","499":"bbfa705a","529":"3c40e671","816":"9b545083","820":"477244a5","934":"df84ef44","972":"58de6431"}[chunkId] + ".chunk.js";
};